import { api } from "../config/api";

// ============================================================
// CANDIDATURA
// ============================================================

// O freelancer autenticado é identificado pelo JWT.
// Não precisa enviar freelancerId.
export const applyToJob = async (jobId) => {
    const response = await api.post(`/Applications/${jobId}/apply`);
    return response.data;
};

// Ainda usa freelancerId porque o backend atual exige esse parâmetro.
// Depois podemos migrar para /Applications/me.
export const cancelApplication = async (jobId) => {
    const userId = localStorage.getItem("userId");

    await api.delete(`/Applications/${jobId}/cancel/${userId}`);
};

// Ainda usa freelancerId porque o backend atual exige esse parâmetro.
// Depois podemos migrar para /Applications/me.
export const getMyApplications = async () => {
    const userId = localStorage.getItem("userId");

    const response = await api.get(`/Applications/freelancer/${userId}`);

    return response.data;
};


// ============================================================
// CANDIDATURAS DE UMA VAGA
// ============================================================

export const getJobApplications = async (jobId) => {
    const response = await api.get(`/Applications/job/${jobId}`);

    return response.data;
};


// ============================================================
// STATUS DA CANDIDATURA
// ============================================================

export const updateApplicationStatus = async (applicationId, status) => {
    const response = await api.put(
        `/Applications/${applicationId}/status`,
        { status }
    );

    return response.data;
};


// ============================================================
// CONVITES
// ============================================================

// Aqui freelancerId NÃO é o usuário autenticado.
// É o freelancer que a empresa está convidando.
// Portanto, deve continuar sendo enviado.
export const inviteFreelancer = async (jobId, freelancerId) => {
    const response = await api.post(
        `/Applications/${jobId}/invite/${freelancerId}`
    );

    return response.data;
};

export const acceptInvite = async (applicationId) => {
    const response = await api.put(
        `/Applications/${applicationId}/accept-invite`
    );

    return response.data;
};

export const declineInvite = async (applicationId) => {
    await api.put(
        `/Applications/${applicationId}/decline-invite`
    );
};


// Ainda usa freelancerId porque o backend atual exige esse parâmetro.
// Depois podemos migrar para /Applications/me/invites.
export const getMyInvites = async () => {
    const userId = localStorage.getItem("userId");

    const response = await api.get(
        `/Applications/freelancer/${userId}/invites`
    );

    return response.data;
};


// ============================================================
// EMPRESA
// ============================================================

// Aqui companyId identifica a empresa cujo histórico está sendo consultado.
// O backend atual valida se ela pertence ao usuário autenticado.
export const getCompanyCompletedJobs = async (companyId) => {
    const response = await api.get(
        `/Applications/company/${companyId}/completed`
    );

    return response.data;
};


// Ainda usa companyId porque o backend atual exige esse parâmetro.
// Depois podemos migrar para /Applications/company/me/early-exits.
export const getCompanyEarlyExits = async () => {
    const userId = localStorage.getItem("userId");

    const response = await api.get(
        `/Applications/company/${userId}/early-exits`
    );

    return response.data;
};